export default __webpack_public_path__ + "images/DS.b11921c.png";